import {
  faGraduationCap as faGraduationCapRegular,
  faHome as faHomeRegular,
  faMessagesQuestion as faMessagesQuestionRegular,
  faSearch as faSearchRegular,
  faUsers as faUsersRegular,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faGraduationCap as faGraduationCapSolid,
  faHome as faHomeSolid,
  faMessagesQuestion as faMessagesQuestionSolid,
  faSearch as faSearchSolid,
  faUsers as faUsersSolid,
} from '@fortawesome/pro-solid-svg-icons'

import { useUser } from '@/client/context/user'
import { getDashboardLiveHelpUrl, getDashboardUrl } from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import type { NavigationItem } from '@/components/Layout/types'

// Shared between desktop and mobile
export function useSharedNavigationItems(): NavigationItem[] {
  const user = useUser()
  const isTutor = hasUserRole(user, 'user:tutor')

  return [
    {
      href: getDashboardUrl(),
      icons: {
        inactive: faHomeRegular,
        active: faHomeSolid,
      },
      labels: {
        desktop: 'Home',
        mobile: 'Home',
      },
      slug: 'home',
    },
    {
      href: getDashboardUrl('sessions'),
      icons: {
        inactive: faSearchRegular,
        active: faSearchSolid,
      },
      labels: {
        desktop: 'Find a Session',
        mobile: 'Sessions',
      },
      slug: 'sessions',
    },
    {
      href: getDashboardUrl('programs'),
      icons: {
        inactive: faGraduationCapRegular,
        active: faGraduationCapSolid,
      },
      labels: {
        desktop: 'Programs',
        mobile: 'Programs',
      },
      slug: 'programs',
    },
    {
      href: isTutor ? getDashboardLiveHelpUrl({ tab: 'give-help' }) : getDashboardLiveHelpUrl({}),
      icons: {
        inactive: faMessagesQuestionRegular,
        active: faMessagesQuestionSolid,
      },
      labels: {
        desktop: 'Homework Help',
        mobile: 'Homework Help',
      },
      slug: 'live-help',
    },
    {
      href: getDashboardUrl('community'),
      icons: {
        inactive: faUsersRegular,
        active: faUsersSolid,
      },
      labels: {
        desktop: 'Community',
        mobile: 'Community',
      },
      slug: 'community',
    },
  ]
}
